<template>
  <div>
    <!-- 添加方案 -->
    <div v-if='traver_between.length == 2?true:false'>
      <!-- 两点间基本信息：打车名称 -->
      <div class="route_mode_style">添加交通方案：
        <span>{{traver_name_between[0]}}</span>-><span>{{traver_name_between[1]}}</span>
      </div>
      <!-- 显示当前交通方案及描述 -->
      <div class="route_mode_style"> 交通方式：
        <!-- 方式标签 -->
        <el-tag size="mini"
                v-if="route_mode=='walking'">徒步</el-tag>
        <el-tag size="mini"
                v-else-if="route_mode=='bicycling'">骑行</el-tag>
        <el-tag size="mini"
                v-else-if="route_mode=='driving'">驾车
        </el-tag>
        <el-tag size="mini"
                v-else-if="route_mode=='transit'">公共交通
        </el-tag>
      </div>
      <!-- ----------------------------打车信息-------------------------- -->
      <div class="route_mode_style">打车搜索：
        <span>
          <el-link style="float:right"
                   type="primary"
                   @click="addTakeTaxiInfo"
                   :underline="false">修改</el-link>
        </span>
        <div>
          <!-- 打车名称 -->
          <div class="traffic_introduce"
               v-html="taxi_introduce"></div>
          <!-- 打车费用 -->
          <div class="traffic_introduce"
               v-html="taxi_fare"></div>
        </div>
      </div>
      <!-- ------------------------------交通简介-------------------------- -->
      <div class="route_mode_style">
        <div>
          交通说明：
          <span v-if="showAddTrafficPlan"
                style="float:right">
            <el-link @click="cancelAddMethods"
                     style="margin-right:10px"
                     type="primary"
                     :underline="false">取消</el-link>
            <el-link @click="saveTrafficPlan"
                     type="primary"
                     :underline="false">确认添加</el-link>
          </span>
          <span v-else
                style="float:right">
            <el-link @click="showAddEditor"
                     type="primary"
                     :underline="false">添加方案</el-link>
          </span>

          <!-------------------------------- 编辑器 ---------------------------->
          <div style="margin-top:10px"
               v-if="showEditor">

            <editor-mini ref="editor_mini"
                         :upLoadImgAddress="`${$ip}/add_image?key_name=traffic_plan_introduce_${this.traffic_id}`"
                         :editor_content="traffic_introduce"
                         @content_change="content_change"></editor-mini>
            <!-- 绑定内容 -->
            <div class="route_mode_style_content">相关交通内容：
              <span>
                <el-link size="mini"
                         style="float:right;color:#fff"
                         type=""
                         :underline="false">选择内容绑定</el-link>
              </span>
            </div>
          </div>
          <!-- 显示交通说明 -->
          <div v-else
               class="traffic_introduce"
               v-html="traffic_introduce"></div>
        </div>
      </div>
      <!-- 方案列表 -->
      <div class="route_mode_style ">
        交通方案：
        <select-traffic-plan @selectTrafficPlan="selectTrafficPlan"
                             :TrafficPlanData="traffic_plan"></select-traffic-plan>

      </div>
    </div>
    <div v-else> 暂无信息 </div>
  </div>
</template>

<script>
import editorMini from '../common/editor/editorV2mini'
import SelectTrafficPlane from '../../components/common/select/SelectTrafficPlan'
export default {
  name: 'traffic-editor',
  components: {
    editorMini,
    'select-traffic-plan': SelectTrafficPlane,
  },
  data() {
    return {
      traffic_id: this.TrafficId,
      showAddTrafficPlan: false,
      showEditor: false,
      traffic_introduce: this.TrafficIntroduce, // 交通路线介绍，将添加到编辑器作为方案
      taxi_introduce: this.TaxiIntroduce, // 打车说明
      taxi_fare: this.TaxiFare, //打车费用预计
      traffic_plan: this.TrafficPlan, // 交通方案
      // 两个迹点id 的列表
      traver_between: this.TraverBetween,
      traver_name_between: this.TraverNameBetween,
      // 坐标
      // 路线明细
      route_mode: this.routeMode,
    }
  },
  props: {
    TrafficId: Number,
    TraverBetween: {
      type: Array,
      default: () => {
        return []
      },
    },
    TraverNameBetween: {
      tyep: Array,
      default: () => {
        return []
      },
    },
    planOfMap: Object,
    TrafficIntroduce: {
      type: String,
      default: '未添加',
    },
    TrafficPlan: {
      type: Array,
      default: () => {
        return []
      },
    },
    TaxiIntroduce: String,
    TaxiFare: String,
    routeMode: String,
  },
  watch: {
    TrafficPlan(newVal) {
      this.traffic_plan = newVal
    },
    TrafficIntroduce(newVal) {
      this.traffic_introduce = newVal
    },
    TaxiIntroduce(newVal) {
      this.taxi_introduce = newVal
    },
    TaxiFare(newVal) {
      this.taxi_fare = newVal
    },
    TrafficId(newVal) {
      this.traffic_id = newVal
    },
    TraverBetween(newVal) {
      this.traver_between = newVal
    },
    TraverNameBetween(newVal) {
      this.traver_name_between = newVal
    },
    routeMode(newVal) {
      this.route_mode = newVal
    },
  },
  mounted() {},
  methods: {
    // 选择交通方案
    selectTrafficPlan(traffic_plan_list) {
      // console.log(traffic_plan_list)
      // console.log(this.TraverBetween[0]);

      // content_id_list: null
      // content_num: null
      // take_taxi: "物质州岛码头"
      // traffic_id: 1
      // traffic_introduce: "<p>距离：3.815公里，耗时约：58分钟,非常适合自己的公路很棒哦！</p>"
      // traffic_plan_id: 3
      // traffic_plan_name: "自驾方案"
      // traffic_type: "walking"

      this.$emit('selectTrafficPlan', traffic_plan_list, this.TraverBetween[0])
    },
    // 修改打车名
    addTakeTaxiInfo() {
      // console.log(this.traffic_id)
      this.$prompt('请输入打车地名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // 发送请求修改打车地名称
          this.$http
            .get(
              `/traver/change_take_taxi_name?traffic_id=${this.traffic_id}&take_taxi_name=${value}`
            )
            .then((res) => {
              if (res.data.errno == '0') {
                this.taxi_introduce = value
                this.$message({
                  type: 'success',
                  message: '已添加',
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    showAddEditor() {
      this.showAddTrafficPlan = !this.showAddTrafficPlan
      this.showEditor = !this.showEditor
    },
    cancelAddMethods() {
      this.showAddTrafficPlan = !this.showAddTrafficPlan
      this.showEditor = !this.showEditor
    },
    // 添加交通方案
    saveTrafficPlan() {
      this.$prompt('请输入方案名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // 构建数据中
          let item = {
            traffic_id: this.traffic_id,
            traffic_plan_name: value,
            traffic_type: this.route_mode,
            plan_of_map: this.planOfMap,
            traffic_introduce: this.traffic_introduce,
          }
          // 方案明细
          // console.log(this.planOfMap)
          this.$http.post('/traver/add_traffic_plan', item).then((res) => {
            if (res.data.errno == '0') {
              this.$message({
                type: 'success',
                message: '已添加',
              })
              this.showAddTrafficPlan = !this.showAddTrafficPlan
              this.showEditor = !this.showEditor
              // 更新交通方案表，通过traffic_id 查找交通信息
              this.$http
                .get(
                  `/traver/get_traffic_info?traffic_id=${this.traffic_id}&traffic_class=1`
                )
                .then((res) => {
                  // console.log('请求亮点直接的数据')
                  if (res.data.errno == '0') {
                    // console.log(res)
                    // 更新交通方案
                    this.traffic_plan = res.data.traffic_plan
                  }
                })
            } else {
              this.$message({
                type: 'info',
                message: res.data.errmsg,
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    content_change(val) {
      this.traffic_introduce = val
    },
  },
}
</script>

<style>
.route_mode_style {
  margin: 10px 0;
  font-size: 13px;
}
.traffic_introduce {
  padding: 5px;
  margin-top: 5px;
  background-color: rgb(233, 233, 233);
}
.route_mode_style_content {
  background-color: #ff5421;
  padding: 10px;
  color: #fff;
}
</style>